import React from 'react';
import PropTypes from 'prop-types';
import PaymentBreakdown from '../containers/PaymentBreakdown';
import EmailPreview from '../containers/EmailPreview';
import PushNotificationPreview from '../containers/PushNotificationPreview';

const PayCampaign = ({ showPushPreview }) => (
  <div className="u-p+">
    <div className="layout">
      <div className="layout__item u-2/5-extralarge-and-up u-1/2-extra-extralarge-and-up">
        <div className="u-mt+">
          <PaymentBreakdown />
        </div>
      </div>
      <div className="layout__item u-3/5-extralarge-and-up u-1/2-extra-extralarge-and-up">
        <hr className="c-separator u-mv u-hidden-for-extralarge-and-up" />
        <div className="layout layout--rev">
          <div className="layout__item u-1/3-medium-and-up">
            <PushNotificationPreview display-if={showPushPreview} />
          </div>
          <div className="layout__item u-2/3-medium-and-up">
            <EmailPreview editable={false} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

PayCampaign.propTypes = {
  showPushPreview: PropTypes.bool.isRequired,
};

export default PayCampaign;
